<template>
  <div class="vh-100 d-flex justify-content-center align-items-center">
    <transition name="fade-up">
      <div
        class="message-container"
        v-if="show"
      >
        <div class="card">
          <div class="card-header">
            <div
              class="icon-block text-center"
              :class="[`text-${msgType}`]"
            >
              <i
                class="fa"
                :class="[`fa-${icon}`]"
              ></i>
            </div>
          </div>
          <div class="card-body">
            {{ this.message }}
          </div>
          <div
            class="card-footer d-flex justify-content-end"
            v-if="buttons.length > 0"
          >

            <v-button
              v-for="button in buttons"
              :key="button"
              :text="availableButtons[button].text"
              :route-to="availableButtons[button].route"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';

const AVAILABLE_BUTTONS = {
  dashboard: {
    text: 'phrase.go_to_dashboard',
    route: { name: 'dashboard' },
  },
  login: {
    text: 'phrase.go_to_login',
    route: { name: 'login' },
  },
  organisation: {
    text: 'phrase.go_to_dashboard',
    route: { name: 'organisation-dashboard' },
  },
  'research-list': {
    text: 'phrase.go_to_researches',
    route: { name: 'organisation-research-list' },
  },
};

export default {
  name: 'MessagePage',
  props: {
    icon: {
      required: true,
      type: String,
    },
    buttons: {
      type: Array,
      default() {
        return ['dashboard'];
      },
    },
    msg: {
      required: true,
      type: String,
    },
    msgType: {
      type: String,
      default() {
        return 'success';
      },
    },
    translateText: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  data() {
    return {
      show: false,
      availableButtons: AVAILABLE_BUTTONS,
    };
  },
  computed: {
    message() {
      if (this.translateText) {
        return this.$t(this.msg);
      }
      return this.msg;
    },
  },
  components: {
    'v-button': Button,
  },
  created() {
    setTimeout(() => {
      this.show = true;
    }, 1);
  },
};
</script>

<style>
.message-container {
  max-width: 95%;
}

@media (min-width: 767px) {
  .message-container {
    max-width: 50%;
  }
}

.icon-block {
  font-size: 40px;
}
</style>
